import React from 'react';
import { MessageSquare, Target, Users, Rocket } from 'lucide-react';

export default function HowItWorks() {
  const steps = [
    {
      icon: <MessageSquare className="w-8 h-8" />,
      title: 'Communication & Planning',
      description: 'Chat naturally with your AI team to plan strategies and coordinate all business activities effectively.'
    },
    {
      icon: <Target className="w-8 h-8" />,
      title: 'Marketing & Branding',
      description: 'Launch powerful marketing campaigns and build a strong brand that attracts more customers.'
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: 'Sales & Revenue',
      description: 'Convert leads into customers and maximize your revenue with AI-powered sales strategies.'
    },
    {
      icon: <Rocket className="w-8 h-8" />,
      title: 'Projects & Growth',
      description: 'Execute projects efficiently and scale your business to new heights with your AI team.'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">How It Works</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Your complete business cycle, powered by the Gekko's AI expertise to maximize your success
          </p>
        </div>
        <div className="relative">
          <div className="absolute top-1/2 left-0 right-0 h-1 bg-blue-200 transform -translate-y-1/2 hidden md:block" />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white mb-4">
                      {step.icon}
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{step.title}</h3>
                    <p className="text-gray-600">{step.description}</p>
                  </div>
                </div>
                <div className="hidden md:block absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-4 bg-blue-500 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold">
                  {index + 1}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}